import { TONES, type ToneName, toneBadgeClassName } from './tones';

/**
 * The four states a slot can be shown in, shared by the calendar, the mobile
 * card list, the legend and the detail sheets.
 *
 * `availability` is the attending's own planning ("Titulaire"); the three
 * others describe an opened agenda slot and mirror its reservation status.
 */
export type SlotStatus = 'availability' | 'open' | 'pending' | 'confirmed';

/** Every status, in legend order — also the default active filter. */
export const SLOT_STATUSES: SlotStatus[] = [
  'availability',
  'open',
  'pending',
  'confirmed',
];

/** Semantic tone per status, following the mockup palette. */
export const SLOT_STATUS_TONE: Record<SlotStatus, ToneName> = {
  availability: 'violet',
  open: 'sky',
  pending: 'amber',
  confirmed: 'emerald',
};

/** Legend translation keys, so labels stay defined in one place. */
export const SLOT_STATUS_LABEL_KEY: Record<SlotStatus, string> = {
  availability: 'office-agenda-slot-legends.availability',
  open: 'office-agenda-slot-legends.open',
  pending: 'office-agenda-slot-legends.pending',
  confirmed: 'office-agenda-slot-legends.confirmed',
};

/**
 * Badge classes for a slot status — soft pill plus tinted text, dark-safe.
 *
 * @param status - the slot status to render
 * @returns Tailwind classes to merge into a `Badge variant="outline"`
 */
export const slotStatusBadgeClassName = (status: SlotStatus): string =>
  toneBadgeClassName(TONES[SLOT_STATUS_TONE[status]]);
